import { stageOf } from '@/components/documents/processing-logic';
import type { DocumentProcessingItem } from '@/lib/api/document-processing';
import type { BaselineDocFileState } from '@/lib/wizard/new-engagement-state';

/**
 * Carry each stored document's process status and pipeline stage from the
 * documents list onto the wizard's upload rows, keyed by document id.
 *
 * Both the baseline-docs step and the base-formation step poll the list
 * and apply this (T-0228): the run may only start once every document is
 * indexed, and the user has usually moved on to step 4 by the time the
 * last one is. Returns null when nothing changed, so the caller can skip
 * the state write and the re-render it would cause.
 */
export function hydrateBaselineFiles(
  files: ReadonlyArray<BaselineDocFileState>,
  remoteById: ReadonlyMap<string, DocumentProcessingItem>,
): BaselineDocFileState[] | null {
  let changed = false;
  const merged = files.map((f) => {
    if (!f.document_id) return f;
    const remote = remoteById.get(f.document_id);
    if (!remote) return f;
    const stage = stageOf(remote);
    if (f.status === remote.process_status && f.stage === stage) return f;
    changed = true;
    return { ...f, status: remote.process_status, stage };
  });
  return changed ? merged : null;
}
